/* eslint-disable react/jsx-no-duplicate-props */
// Don't worry about duplicated inputProps it is the feature of materail ui
// https://github.com/mui-org/material-ui/issues/8232
// https://github.com/mui-org/material-ui/issues/10064#issuecomment-373190215

import { Grid } from '@mui/material';
import { isString } from 'lodash';
import React, { useEffect } from 'react';

import { TextField } from '../../../../../../../common/components/TextField/TextField';
import { getProcessedStatus } from '../../../ChargerConfigurationHelper';
import { ConfigurationFieldLabel } from '../../ConfigurationFieldLabel';
import { CurrentConfigureValue } from '../../CurrentConfigureValue';

const ChargerConfigurationTextField = (props) => {
  const {
    label,
    min,
    max,
    type,
    multiline,
    disabled,
    description,
    status,
    inputProps,
    input: { name, value, onChange },
    meta: { dirty, form, error, touched },
    onFieldChange,
    clearButton,
    isBatchUpdate,
    isModal,
    onBatchFieldChange,
    currentValue,
    setIsShouldValidate,
  } = props;

  useEffect(() => isModal && setIsShouldValidate(!!error), []);

  const handleChange = (event) => {
    onChange(event.target.value);
    onFieldChange({ fieldName: name });
    isModal && setIsShouldValidate(true);
  };

  const handleClick = (event) => {
    if (isModal) {
      handleChange(event);
      onBatchFieldChange();
    }
  };

  const rows = multiline ? 4 : undefined;

  const processedStatus = getProcessedStatus(isBatchUpdate ? dirty || touched : dirty, status);

  const wrappedLabel = <ConfigurationFieldLabel label={label} description={description} status={processedStatus} />;

  const currentValueComponent = isBatchUpdate ? (
    props.batchUpdateButton(dirty || touched)
  ) : (
    <CurrentConfigureValue dirty={dirty} status={processedStatus} currentValue={currentValue} />
  );

  return (
    <Grid container spacing={2}>
      <Grid item md={6} xs={12}>
        <div className="charger-configuration-field">
          <TextField
            value={value}
            name={name}
            label={wrappedLabel}
            type={type}
            min={min}
            max={max}
            rows={rows}
            disabled={disabled}
            inputProps={{ form }}
            InputProps={{
              ...inputProps,
              onClick: handleClick,
            }}
            onChange={handleChange}
            multiline={multiline}
            error={!!error}
            fullWidth
            helperText={isString(error) ? error : null}
          />
          {clearButton({ processed: processedStatus, actual: status })}
        </div>
      </Grid>
      {!isModal && (
        <Grid item className="current-value-grid-container">
          {currentValueComponent}
        </Grid>
      )}
    </Grid>
  );
};

export default ChargerConfigurationTextField;
